import smoothScrollPolyfill from "smoothscroll-polyfill"
smoothScrollPolyfill.polyfill()
;(window as any).__forceSmoothScrollPolyfill__ = true
